import React from "react";
import { Box } from "@mui/material";
import "moment/locale/hu";
import { OcCurrency } from "oc/components";

interface MyHrSalarySummaryCurrencyTooltipProps {
  label: string;
  value: number;
}

export const MyHrSalarySummaryCurrencyTooltip = ({
  label,
  value,
}: MyHrSalarySummaryCurrencyTooltipProps) => {
  return (
    <Box style={{ fontSize: "16px", lineHeight: "20px", padding: "2px 8px" }}>
      <span>{`${label}: `}</span>
      {OcCurrency({ value: value })}
    </Box>
  );
};

export default MyHrSalarySummaryCurrencyTooltip;
